export default {
  root: {
    color: "#366b92",
    "&$focused": {
      color: "#366b92"
    }
  }
};
